import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {BASE_URL} from '../config';

function EditProductModal({show, product, onHide, onSave}) {
    const [editData, setEditData] = useState({});
    const [locations, setLocations] = useState([]);
    const [warehouses, setWarehouses] = useState([]);

    useEffect(() => {
        if (product) {
            // Create a clean copy of the product data
            const cleanProduct = { ...product };
            if (cleanProduct.image) {
                cleanProduct.image_filename = cleanProduct.image;
                delete cleanProduct.image;
            }
            setEditData(cleanProduct);
            fetchLocations();
            fetchWarehouses();
        } else {
            setEditData({});
        }
    }, [product]);

    const fetchLocations = () => {
        fetch(`${BASE_URL}/api/locations`)
            .then(response => response.json())
            .then(data => setLocations(data))
            .catch(error => console.error('Error fetching locations:', error));
    };

    const fetchWarehouses = () => {
        fetch(`${BASE_URL}/api/warehouses`)
            .then(response => response.json())
            .then(data => setWarehouses(data))
            .catch(error => console.error('Error fetching warehouses:', error));
    };

    const handleChange = (key, value) => {
        setEditData(prevData => ({
            ...prevData,
            [key]: value
        }));
    };

    const handleSave = () => {
        onSave(editData);
    };

    if (!product) return null;

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Edytuj produkt</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form>
                    {Object.keys(editData).map(key => {
                        if (key === 'buy_price') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`edit-${key}`} className="form-label">Cena zakupu</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control"
                                        id={`edit-${key}`}
                                        value={editData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'category') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`edit-${key}`} className="form-label">Kategoria</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`edit-${key}`}
                                        value={editData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'sale_price') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`edit-${key}`} className="form-label">Cena sprzedaży</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control"
                                        id={`edit-${key}`}
                                        value={editData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'consignment_price') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`edit-${key}`} className="form-label">Cena w komisie</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control"
                                        id={`edit-${key}`}
                                        value={editData[key] ?? ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        
                       
                        if (key === 'note') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`edit-${key}`} className="form-label">Notatka</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`edit-${key}`}
                                        value={editData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }   
                        if (key === 'shop' || key === 'order') {
                            return null;
                        }
                        if (key === 'ksfv') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`edit-${key}`} className="form-label">UKS/FV</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`edit-${key}`}
                                        value={editData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key.includes('id')) {
                            return null;
                        }

                        if (key === 'lokalizacja') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`edit-${key}`} className="form-label">Lokalizacja</label>
                                    <select
                                        className="form-select"
                                        id={`edit-${key}`}
                                        value={editData[key]}
                                        onChange={e => handleChange(key, e.target.value)}
                                    >
                                        <option value="">Wybierz lokalizację</option>
                                        {locations.map(location => (
                                            <option key={location.name} value={location.name}>
                                                {location.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            );
                        }

                        if (key === 'magazyn') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`edit-${key}`} className="form-label">Magazyn</label>
                                    <select
                                        className="form-select"
                                        id={`edit-${key}`}
                                        value={editData[key]}
                                        onChange={e => handleChange(key, e.target.value)}
                                    >
                                        <option value="">Wybierz magazyn</option>
                                        {warehouses.map(warehouse => (
                                            <option key={warehouse.name} value={warehouse.name}>
                                                {warehouse.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            );
                        }

                        return (
                            <div key={key} className="mb-3">
                                <label htmlFor={`edit-${key}`} className="form-label">{key}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id={`edit-${key}`}
                                    value={editData[key]}
                                    onChange={e => handleChange(key, e.target.value)}
                                    disabled={['media', 'image','date','image_filename','is_sold'].includes(key)}
                                />
                            </div>
                        );
                    })}
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Zamknij</Button>
                <Button variant="primary" onClick={handleSave}>Zapisz zmiany</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditProductModal;
